"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ferrara": {
    "17933acc": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "viconovo": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "d49b6b30": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "villanova": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "e2c991f8": [{
      "hkey": "ff460948",
      "slug": "coccomaro-di-cona-e-focomorto-aguscello",
      "name": "Coccomaro dI Cona e Focomorto-Aguscello",
      "primary": true,
      "skipSearch": false
    }],
    "aguscello": [{
      "hkey": "ff460948",
      "slug": "coccomaro-di-cona-e-focomorto-aguscello",
      "name": "Coccomaro dI Cona e Focomorto-Aguscello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "fd33b072": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "albarea": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "36073a4e": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "skipSearch": false
    }],
    "baura": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7cede199": [{
      "hkey": "a3313f80",
      "slug": "casaglia-ravelle",
      "name": "Casaglia-Ravelle",
      "primary": true,
      "skipSearch": false
    }],
    "casaglia": [{
      "hkey": "a3313f80",
      "slug": "casaglia-ravelle",
      "name": "Casaglia-Ravelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "54ee8487": [{
      "hkey": "7b36e26f",
      "slug": "porotto-cassana",
      "name": "Porotto-Cassana",
      "primary": true,
      "skipSearch": false
    }],
    "cassana": [{
      "hkey": "7b36e26f",
      "slug": "porotto-cassana",
      "name": "Porotto-Cassana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "971bcaed": [{
      "hkey": "13325c32",
      "slug": "fiera-via-bologna",
      "name": "Fiera-Via Bologna",
      "primary": true,
      "skipSearch": false
    }],
    "chiesuol-del-fosso": [{
      "hkey": "13325c32",
      "slug": "fiera-via-bologna",
      "name": "Fiera-Via Bologna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "6a7c70a3": [{
      "hkey": "ff460948",
      "slug": "coccomaro-di-cona-e-focomorto-aguscello",
      "name": "Coccomaro dI Cona e Focomorto-Aguscello",
      "primary": true,
      "skipSearch": false
    }],
    "cocomaro-di-cona": [{
      "hkey": "ff460948",
      "slug": "coccomaro-di-cona-e-focomorto-aguscello",
      "name": "Coccomaro dI Cona e Focomorto-Aguscello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c5bab41d": [{
      "hkey": "ff460948",
      "slug": "coccomaro-di-cona-e-focomorto-aguscello",
      "name": "Coccomaro dI Cona e Focomorto-Aguscello",
      "primary": true,
      "skipSearch": false
    }],
    "cocomaro-di-focomorto": [{
      "hkey": "ff460948",
      "slug": "coccomaro-di-cona-e-focomorto-aguscello",
      "name": "Coccomaro dI Cona e Focomorto-Aguscello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "eb6c1c77": [{
      "hkey": "f2fec797",
      "slug": "codrea-cona-quartesana",
      "name": "Codrea-Cona-Quartesana",
      "primary": true,
      "skipSearch": false
    }],
    "codrea": [{
      "hkey": "f2fec797",
      "slug": "codrea-cona-quartesana",
      "name": "Codrea-Cona-Quartesana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "a93a33b0": [{
      "hkey": "f2fec797",
      "slug": "codrea-cona-quartesana",
      "name": "Codrea-Cona-Quartesana",
      "primary": true,
      "skipSearch": false
    }],
    "cona": [{
      "hkey": "f2fec797",
      "slug": "codrea-cona-quartesana",
      "name": "Codrea-Cona-Quartesana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6709ae55": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "skipSearch": false
    }],
    "corlo": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "4eb41e9b": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "skipSearch": false
    }],
    "correggio": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "43cfae70": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "denore": [{
      "hkey": "5c487c56",
      "slug": "albarea-denore-viconovo-villanova",
      "name": "Albarea-Denore-Viconovo-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3bd7c5c8": [{
      "hkey": "279eea0c",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "d1470d44",
      "slug": "san-paolo",
      "name": "San Paolo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "cbf51702",
      "slug": "santa-maria-in-vado",
      "name": "Santa Maria in Vado",
      "primary": false,
      "skipSearch": false
    }],
    "entro-mura": [{
      "hkey": "279eea0c",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "df593b01": [{
      "hkey": "1e3de598",
      "slug": "fossa-d-albero-francolino-pescara",
      "name": "Fossa D'Albero-Francolino-Pescara",
      "primary": true,
      "skipSearch": false
    }],
    "fossa-d-albero": [{
      "hkey": "1e3de598",
      "slug": "fossa-d-albero-francolino-pescara",
      "name": "Fossa D'Albero-Francolino-Pescara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6ec39e30": [{
      "hkey": "71597419",
      "slug": "fossanova-san-marco-fossanova-san-biagio-torre-della-fossa",
      "name": "Fossanova San Marco-Fossanova San Biagio-Torre della Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "fossanova-san-biagio": [{
      "hkey": "71597419",
      "slug": "fossanova-san-marco-fossanova-san-biagio-torre-della-fossa",
      "name": "Fossanova San Marco-Fossanova San Biagio-Torre della Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "2716f060": [{
      "hkey": "71597419",
      "slug": "fossanova-san-marco-fossanova-san-biagio-torre-della-fossa",
      "name": "Fossanova San Marco-Fossanova San Biagio-Torre della Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "fossanova-san-marco": [{
      "hkey": "71597419",
      "slug": "fossanova-san-marco-fossanova-san-biagio-torre-della-fossa",
      "name": "Fossanova San Marco-Fossanova San Biagio-Torre della Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9af1335d": [{
      "hkey": "1e3de598",
      "slug": "fossa-d-albero-francolino-pescara",
      "name": "Fossa D'Albero-Francolino-Pescara",
      "primary": true,
      "skipSearch": false
    }],
    "francolino": [{
      "hkey": "1e3de598",
      "slug": "fossa-d-albero-francolino-pescara",
      "name": "Fossa D'Albero-Francolino-Pescara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "576a7c79": [{
      "hkey": "4dcd2f82",
      "slug": "gaibanella-gaibana-sant-edigio",
      "name": "Gaibanella-Gaibana-Sant'Edigio",
      "primary": true,
      "skipSearch": false
    }],
    "gaibana": [{
      "hkey": "4dcd2f82",
      "slug": "gaibanella-gaibana-sant-edigio",
      "name": "Gaibanella-Gaibana-Sant'Edigio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "60d4a6b6": [{
      "hkey": "4dcd2f82",
      "slug": "gaibanella-gaibana-sant-edigio",
      "name": "Gaibanella-Gaibana-Sant'Edigio",
      "primary": true,
      "skipSearch": false
    }],
    "gaibanella": [{
      "hkey": "4dcd2f82",
      "slug": "gaibanella-gaibana-sant-edigio",
      "name": "Gaibanella-Gaibana-Sant'Edigio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "085c0a79": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "skipSearch": false
    }],
    "malborghetto": [{
      "hkey": "1717a8b0",
      "slug": "baura-corlo-correggio",
      "name": "Baura-Corlo-Correggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "6bde1f29": [{
      "hkey": "40c88c0e",
      "slug": "malborghetto-di-boara-via-santa-margherita",
      "name": "Malborghetto di Boara-Via Santa Margherita",
      "primary": true,
      "skipSearch": false
    }],
    "malborghetto-di-boara": [{
      "hkey": "40c88c0e",
      "slug": "malborghetto-di-boara-via-santa-margherita",
      "name": "Malborghetto di Boara-Via Santa Margherita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e75e6505": [{
      "hkey": "37d32e0b",
      "slug": "marrara-monestirolo",
      "name": "Marrara-Monestirolo",
      "primary": true,
      "skipSearch": false
    }],
    "marrara": [{
      "hkey": "37d32e0b",
      "slug": "marrara-monestirolo",
      "name": "Marrara-Monestirolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "20cb4492": [{
      "hkey": "37d32e0b",
      "slug": "marrara-monestirolo",
      "name": "Marrara-Monestirolo",
      "primary": true,
      "skipSearch": false
    }],
    "monestirolo": [{
      "hkey": "37d32e0b",
      "slug": "marrara-monestirolo",
      "name": "Marrara-Monestirolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "2bcd843b": [{
      "hkey": "248b7a68",
      "slug": "montalbano-san-martino-uccellino",
      "name": "Montalbano-San Martino-Uccellino",
      "primary": true,
      "skipSearch": false
    }],
    "montalbano": [{
      "hkey": "248b7a68",
      "slug": "montalbano-san-martino-uccellino",
      "name": "Montalbano-San Martino-Uccellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "0c4ed227": [{
      "hkey": "1e3de598",
      "slug": "fossa-d-albero-francolino-pescara",
      "name": "Fossa D'Albero-Francolino-Pescara",
      "primary": true,
      "skipSearch": false
    }],
    "pescara": [{
      "hkey": "1e3de598",
      "slug": "fossa-d-albero-francolino-pescara",
      "name": "Fossa D'Albero-Francolino-Pescara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "3120c218": [{
      "hkey": "69e2b0c8",
      "slug": "focomorto-pontegradella",
      "name": "Focomorto-Pontegradella",
      "primary": true,
      "skipSearch": false
    }],
    "pontegradella": [{
      "hkey": "69e2b0c8",
      "slug": "focomorto-pontegradella",
      "name": "Focomorto-Pontegradella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d09ce0f3": [{
      "hkey": "197b299a",
      "slug": "quacchio-via-pomposa",
      "name": "Quacchio-Via Pomposa",
      "primary": true,
      "skipSearch": false
    }],
    "quacchio": [{
      "hkey": "197b299a",
      "slug": "quacchio-via-pomposa",
      "name": "Quacchio-Via Pomposa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fdb9d457": [{
      "hkey": "f2fec797",
      "slug": "codrea-cona-quartesana",
      "name": "Codrea-Cona-Quartesana",
      "primary": true,
      "skipSearch": false
    }],
    "quartesana": [{
      "hkey": "f2fec797",
      "slug": "codrea-cona-quartesana",
      "name": "Codrea-Cona-Quartesana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "95e1880d": [{
      "hkey": "a3313f80",
      "slug": "casaglia-ravelle",
      "name": "Casaglia-Ravelle",
      "primary": true,
      "skipSearch": false
    }],
    "ravalle": [{
      "hkey": "a3313f80",
      "slug": "casaglia-ravelle",
      "name": "Casaglia-Ravelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "f027aa9f": [{
      "hkey": "1327f6a9",
      "slug": "san-bartolomeo-in-bosco-spinazzino",
      "name": "San Bartolomeo In Bosco-Spinazzino",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo-in-bosco": [{
      "hkey": "1327f6a9",
      "slug": "san-bartolomeo-in-bosco-spinazzino",
      "name": "San Bartolomeo In Bosco-Spinazzino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e7335c7d": [{
      "hkey": "248b7a68",
      "slug": "montalbano-san-martino-uccellino",
      "name": "Montalbano-San Martino-Uccellino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "248b7a68",
      "slug": "montalbano-san-martino-uccellino",
      "name": "Montalbano-San Martino-Uccellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "64eb7aab": [{
      "hkey": "d968bb8f",
      "slug": "borgo-scoline-fondoreno",
      "name": "Borgo Scoline-Fondoreno",
      "primary": true,
      "skipSearch": false
    }],
    "scoline": [{
      "hkey": "d968bb8f",
      "slug": "borgo-scoline-fondoreno",
      "name": "Borgo Scoline-Fondoreno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "73fb00bd": [{
      "hkey": "1327f6a9",
      "slug": "san-bartolomeo-in-bosco-spinazzino",
      "name": "San Bartolomeo In Bosco-Spinazzino",
      "primary": true,
      "skipSearch": false
    }],
    "spinazzino": [{
      "hkey": "1327f6a9",
      "slug": "san-bartolomeo-in-bosco-spinazzino",
      "name": "San Bartolomeo In Bosco-Spinazzino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferrara"
    }],
    "cce2091a": [{
      "hkey": "13325c32",
      "slug": "fiera-via-bologna",
      "name": "Fiera-Via Bologna",
      "primary": true,
      "skipSearch": false
    }],
    "via-bologna": [{
      "hkey": "13325c32",
      "slug": "fiera-via-bologna",
      "name": "Fiera-Via Bologna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;